export const GET_USERS_DATA='get/usersdata'
export const SET_CURRENT_USER="set/current"
export const LOGOUT_USER='logout/user'
export const UPDATE_CART_TOTAL= 'UPDATE_CART_TOTAL'
